<template>
    <div class="h-100 d-flex flex-column">
        <header id="Page_Title" class="col-12 material-card" v-show="hasTitle">
            <h4 class="mb-0" v-if="pageTitle">{{ pageTitle }}</h4>
            <template v-else> <slot name="title"></slot></template>
        </header>
        <!-- Start of page layout -->
        <div class="container-fluid p-0 flex-grow-1 overflow-auto" id="Page" :class="isFullPage ? 'is-full-page' : ''">
            <div id="Page_Row" class="row g-0">
                <aside class="col me-0 me-md-3" v-show="hasSideNav" id="Page__Aside" ref="sideNav">
                    <a
                        class="collapse-control p-2"
                        data-bs-toggle="collapse"
                        href="#Page__SideNav"
                        role="button"
                        aria-expanded="false"
                        aria-controls="Page__SideNav"
                    >
                        <i class="fas fa-bars me-2"></i> {{ activeRouteName }}
                    </a>
                    <div class="collapse" id="Page__SideNav">
                        <section class="nav-section" id="Page__Filter">
                            <slot name="filter"></slot>
                        </section>
                        <section class="nav-section" :class="hasButtons ? 'has-buttons' : ''" id="Page__Navigation">
                            <slot name="navigation"></slot>
                        </section>
                    </div>
                </aside>
                <main
                    class="position-relative col-12"
                    :class="`${contentClass} ${hasSideNav ? 'has-side-nav col-lg-10' : ''} ${
                        hasPageScroll ? 'page-scroll-control' : hasListScroll ? 'list-scroll-control' : ''
                    }`"
                    id="Page__Content"
                >
                    <div :class="`content-wrapper ${hasButtons ? 'has-buttons' : ''}`">
                        <slot name="content"></slot>
                    </div>
                    <div class="buttons-wrapper" v-show="hasButtons">
                        <slot name="buttons"></slot>
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>

<style src="./PageLayout.scss"></style>

<script lang="ts" src="./PageLayout.ts"></script>
